export enum Lang {
	GERMAN = 'de',
	ENGLISH = 'en',
}
